import { useTranslation } from "../../../../locale/useTranslation";

const EditRoundButton = (props) => {
    const lang = useTranslation();

    return <button disabled={props.disabled ?? false} title={props.title ?? lang.edit_button_tooltip} type="submit" onClick={props.onClick} style={{ margin: "0px 02px", pointerEvents: props.disabled ? "none" : "auto", boxShadow: "none" }} className="btn btn-default btn-circle btn-my">
        <i className="fa fa-pen fa-fw img-circle"></i>

    </button>
}

export default EditRoundButton;
